import React from 'react';

import _ from 'lodash';

import FieldGroup from '../Fields/FieldGroup';
import Field from '../Fields/Field';
import InputTextField from '../Fields/InputTextField';
import InputSelectField from '../Fields/InputSelectField';
import InputPhoneNumberField from './InputPhoneNumberField';
import InputRadioGroupField from './InputRadioGroupField';
import ActionButton from '../Common/ActionButton';

import './InputPayorPanel.scss';
import InvoiceEmailRecipients from './InvoiceEmailRecipients';
import featureFlags from '../../featureFlags';
import SubscriptionDetailReassignPanel from '../Pages/Subscription/SubscriptionDetailReassignPanel';
import InputNumberField from './InputNumberField';

class InputPayorPanel extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      displayAlternateContactInfoPanel: false,
    };
  }

  _onInputChange(inputId) {
    return value => {
      const payor = _.cloneDeep(this.props.payor);
      payor.fields[inputId].value = value;

      this.props.onPayorInputChange(payor);
    };
  }

  _onLineItemEntryChange = (ident, value) => {
    this._onChange('billing_emails')(value);
  }

  _onChange(inputId) {
    return value => {
      const { onPayorInputChange } = this.props;

      const lineItem = _.cloneDeep(this.props.payor);
      lineItem.fields[inputId].value = value;

      onPayorInputChange(lineItem);
    };
  }

  onReassignClick = () => {
    this.props.setReassignMode(true);
  }

  onCancelClick = () => {
    this.props.setReassignMode(false);
  }

  render() {
    const {
      payor,
      payorPassword,
      subscriptionInvoiceNotes,
      fieldConfiguration: {
        payor: payorFieldConfig,
        subscription: subscriptionFieldConfig,
      },
      editMode,
      newMode,
      reassignEmailMode,
      subscriptionStatus,
      billingProfile,
      taxExemptStatus,
      onSubscriptionExemptStatusChange,
      subscriptionId,
      numberOfParkingSpaces,
    } = this.props;

    return (
      <div className="parkchirp--input-payor-panel">
        <FieldGroup>
        {(!newMode) &&
          <Field label="Tax Exempt"
                id="parkchirp--subscription--tax-exempt"
                layout="columns">
                <InputRadioGroupField inputId="parkchirp--subscription--tax-exempt"
                  options={subscriptionFieldConfig.tax_exempt.options}
                  value={taxExemptStatus}
                  onChange={onSubscriptionExemptStatusChange}
                  editMode={editMode}
                />
              </Field>
        } 
          <div style={{ display: 'flex', flexDirection: 'row' }}>
            <div style={{ width: '50%' }}>
              <Field label={featureFlags.ACCOUNT_ID ? "Subscriber Type" : "Payor Type"}
                id="parkchirp--payor--type"
                layout="columns">
                <InputSelectField inputId="parkchirp--payor--type"
                  options={[
                    { value: null, label: '' },
                    ...payorFieldConfig.type.options
                  ]}
                  value={payor.fields.type.value}
                  onChange={this._onInputChange('type')}
                  editMode={(newMode || editMode)}
                />
              </Field>
              {!featureFlags.ACCOUNT_ID &&
                <Field label="Status"
                  id="parkchirp--payor--status"
                  layout="columns">
                  <InputSelectField inputId="parkchirp--payor--status"
                    options={[
                      { value: null, label: '' },
                      ...payorFieldConfig.status.options
                    ]}
                    value={payor.fields.status.value}
                    onChange={this._onInputChange('status')}
                    editMode={newMode}
                  />
                </Field>
              }
              {!newMode && featureFlags.ACCOUNT_ID &&
                <Field label="Subscription Status"
                  id="parkchirp--payor--status"
                  layout="columns">
                  <InputSelectField inputId="parkchirp--payor--status"
                    options={subscriptionFieldConfig.status.options}
                    value={subscriptionStatus}
                    editMode={false}
                  />
                </Field>
              }
            </div>
            {(newMode) &&
              <div style={{ width: '50%' }}>
                <Field label="Password"
                  id="parkchirp--payor--password"
                  layout="columns">
                  <InputTextField inputId="parkchirp--payor--password"
                    value={payorPassword}
                    onChange={this.props.onPayorPasswordInputChange}
                    editMode={true}
                  />
                </Field>
              </div>
            }
            {(!newMode) &&
              <div style={{ width: '50%' }}>
                <Field label={featureFlags.ACCOUNT_ID ? "Subscriber ID" : "Payor ID"}
                  id="parkchirp--payor--readable-id"
                  layout="columns">
                  <InputTextField inputId="parkchirp--payor--readable-id"
                    value={payor.fields.readable_id.value}
                    editMode={false}
                  />
                </Field>
                {featureFlags.ACCOUNT_ID && billingProfile &&
                  <Field label="Billing profile"
                    id="parkchirp--payor--readable-id"
                    layout="columns">
                    <InputTextField inputId="parkchirp--payor--readable-id"
                      value={billingProfile.name}
                      editMode={false}
                    />
                  </Field>
                }
              </div>
            }
          </div>
        </FieldGroup>
        <FieldGroup label="Primary Contact">
          <div className="parkchirp--contact-info-panel">
            <div className="parkchirp--contact-info-panel-row">
              {(newMode || editMode) &&
                <React.Fragment>
                  <Field label="First Name"
                    id="parkchirp--payor--billing-firstname"
                    containerClasses={['parkchirp--contact-info-panel-field--first-name']}
                    layout="stacked">
                    <InputTextField inputId="parkchirp--payor--billing-firstname"
                      value={payor.fields.billing_firstname.value}
                      onChange={this._onInputChange('billing_firstname')}
                      editMode={(newMode || editMode)}
                    />
                  </Field>
                  <Field label="Last Name"
                    id="parkchirp--payor--billing-lastname"
                    containerClasses={['parkchirp--contact-info-panel-field--last-name']}
                    layout="stacked">
                    <InputTextField inputId="parkchirp--payor--billing-lastname"
                      value={payor.fields.billing_lastname.value}
                      onChange={this._onInputChange('billing_lastname')}
                      editMode={(newMode || editMode)}
                    />
                  </Field>
                </React.Fragment>
              }
              {(!newMode && !editMode) &&
                <Field label="Name"
                  layout="stacked">
                  <p>
                    {payor.fields.billing_firstname.value}
                    {(payor.fields.billing_firstname.value !== null) && <span> </span>}
                    {payor.fields.billing_lastname.value}
                  </p>
                </Field>
              }
            </div>
            <div className="parkchirp--contact-info-panel-row">
              <Field label="Phone"
                id="parkchirp--payor--billing-phone"
                containerClasses={['parkchirp--contact-info-panel-field--phone']}
                layout="stacked">
                <InputPhoneNumberField inputId="parkchirp--payor--billing-phone"
                  value={payor.fields.billing_phone.value}
                  onChange={this._onInputChange('billing_phone')}
                  editMode={(newMode || editMode)}
                />
              </Field>
              <Field label="Work Phone"
                id="parkchirp--payor--billing-work-phone"
                containerClasses={['parkchirp--contact-info-panel-field--work-phone']}
                layout="stacked">
                <InputPhoneNumberField inputId="parkchirp--payor--billing-work-phone"
                  value={payor.fields.billing_work_phone.value}
                  onChange={this._onInputChange('billing_work_phone')}
                  editMode={(newMode || editMode)}
                />
              </Field>
              <Field label="Email"
                id="parkchirp--payor--billing-email"
                containerClasses={['parkchirp--contact-info-panel-field--email']}
                layout="stacked">
                <InputTextField inputId="parkchirp--payor--billing-email"
                  value={payor.fields.billing_email.value}
                  onChange={this._onInputChange('billing_email')}
                  editMode={newMode}
                />
              </Field>
              {(!editMode && !newMode && !reassignEmailMode) &&
                <ActionButton label="Reassign Primary Contact"
                  classNames={['parkchirp--action-button--reassign-primary-contact']}
                  onClick={this.onReassignClick}
                />
              }
              {reassignEmailMode &&
                <SubscriptionDetailReassignPanel
                  payor={payor}
                  subscriptionId={subscriptionId}
                  onCancelClick={this.onCancelClick}
                  refreshSubscription={this.props.refreshSubscription}
                />
              }
            </div>
            <div className="parkchirp--contact-info-panel-row">
              {(newMode || editMode) &&
                <React.Fragment>
                  <Field label="Street Address"
                    id="parkchirp--payor--billing-street"
                    containerClasses={['parkchirp--contact-info-panel-field--street']}
                    layout="stacked">
                    <InputTextField inputId="parkchirp--payor--billing-street"
                      value={payor.fields.billing_street.value}
                      onChange={this._onInputChange('billing_street')}
                      editMode={(newMode || editMode)}
                    />
                  </Field>
                  <Field label="City"
                    id="parkchirp--payor--billing-city"
                    containerClasses={['parkchirp--contact-info-panel-field--city']}
                    layout="stacked">
                    <InputTextField inputId="parkchirp--payor--billing-city"
                      value={payor.fields.billing_city.value}
                      onChange={this._onInputChange('billing_city')}
                      editMode={(newMode || editMode)}
                    />
                  </Field>
                  <Field label="State"
                    id="parkchirp--payor--billing-state"
                    containerClasses={['parkchirp--contact-info-panel-field--state']}
                    layout="stacked">
                    <InputSelectField inputId="parkchirp--payor--billing-state"
                      options={[{ value: null, label: '' }, ...payorFieldConfig.billing_state.options]}
                      value={payor.fields.billing_state.value}
                      onChange={this._onInputChange('billing_state')}
                      editMode={(newMode || editMode)}
                    />
                  </Field>
                  <Field label="ZIP"
                    id="parkchirp--payor--billing-zip"
                    containerClasses={['parkchirp--contact-info-panel-field--zip']}
                    layout="stacked">
                    <InputTextField inputId="parkchirp--payor--billing-zip"
                      value={payor.fields.billing_zip.value}
                      onChange={this._onInputChange('billing_zip')}
                      editMode={(newMode || editMode)}
                    />
                  </Field>
                </React.Fragment>
              }
              {(!newMode && !editMode) &&
                <Field label="Address"
                  layout="stacked">
                  <p>
                    {payor.fields.billing_street.value}
                  </p>
                  <p>
                    {payor.fields.billing_city.value}
                    {(payor.fields.billing_city.value !== null) && <span>, </span>}
                    {payor.fields.billing_state.value}
                    {(payor.fields.billing_zip.value !== null) && <span> </span>}
                    {payor.fields.billing_zip.value}
                  </p>
                </Field>
              }
            </div>
          </div>
        </FieldGroup>
        <FieldGroup label="Invoice Email Recipients">
          <div className="parkchirp--contact-info-panel">
            <div className="parkchirp--contact-info-panel-row">
              <InvoiceEmailRecipients onLineItemEntryChange={this._onLineItemEntryChange} editMode={editMode} payor={payor} />
            </div>
          </div>
        </FieldGroup>
        <FieldGroup label="Billing Address">
          <div className="parkchirp--contact-info-panel">
            <div className="parkchirp--contact-info-panel-row">
              <Field label="Billing Name (Company Name)"
                id="parkchirp--payor--info-name"
                containerClasses={['parkchirp--contact-info-panel-field--company-name']}
                layout="stacked">
                <InputTextField inputId="parkchirp--payor--info-name"
                  value={payor.fields.info_name.value}
                  onChange={this._onInputChange('info_name')}
                  editMode={(newMode || editMode)}
                />
              </Field>
              <Field label="Attention"
                id="parkchirp--payor--info-attn"
                containerClasses={['parkchirp--contact-info-panel-field--attention']}
                layout="stacked">
                <InputTextField inputId="parkchirp--payor--info-attn"
                  value={payor.fields.info_attn.value}
                  onChange={this._onInputChange('info_attn')}
                  editMode={(newMode || editMode)}
                />
              </Field>
            </div>
            <div className="parkchirp--contact-info-panel-row">
              <Field label="Street Address"
                id="parkchirp--payor--info-street"
                containerClasses={['parkchirp--contact-info-panel-field--street']}
                layout="stacked">
                <InputTextField inputId="parkchirp--payor--info-street"
                  value={payor.fields.info_street.value}
                  onChange={this._onInputChange('info_street')}
                  editMode={(newMode || editMode)}
                />
              </Field>
              <Field label="City"
                id="parkchirp--payor--info-city"
                containerClasses={['parkchirp--contact-info-panel-field--city']}
                layout="stacked">
                <InputTextField inputId="parkchirp--payor--info-city"
                  value={payor.fields.info_city.value}
                  onChange={this._onInputChange('info_city')}
                  editMode={(newMode || editMode)}
                />
              </Field>
              <Field label="State"
                id="parkchirp--payor--info-state"
                containerClasses={['parkchirp--contact-info-panel-field--state']}
                layout="stacked">
                <InputSelectField inputId="parkchirp--payor--info-state"
                  options={[{ value: null, label: '' }, ...payorFieldConfig.info_state.options]}
                  value={payor.fields.info_state.value}
                  onChange={this._onInputChange('info_state')}
                  editMode={(newMode || editMode)}
                />
              </Field>
              <Field label="ZIP"
                id="parkchirp--payor--info-zip"
                containerClasses={['parkchirp--contact-info-panel-field--zip']}
                layout="stacked">
                <InputTextField inputId="parkchirp--payor--info-zip"
                  value={payor.fields.info_zip.value}
                  onChange={this._onInputChange('info_zip')}
                  editMode={(newMode || editMode)}
                />
              </Field>
            </div>
          </div>
        </FieldGroup>
        <FieldGroup label="Subscription Invoice Notes">
          <Field id="parkchirp--payor--subscription-invoice-notes"
            layout="stacked">
            <InputTextField inputId="parkchirp--payor--subscription-invoice-notes"
              value={subscriptionInvoiceNotes}
              onChange={this.props.onSubscriptionInvoiceNotesChange}
              editMode={(newMode || editMode)}
              multiLine={true}
            />
          </Field>
        </FieldGroup>
        <FieldGroup label="Contact Information Notes">
          <Field id="parkchirp--payor--contact-notes"
            layout="stacked">
            <InputTextField inputId="parkchirp--payor--contact-notes"
              value={payor.fields.contact_notes.value}
              onChange={this._onInputChange('contact_notes')}
              editMode={(newMode || editMode)}
              multiLine={true}
            />
          </Field>
        </FieldGroup>
        <FieldGroup label="Integration Settings">
          <Field
            label="Number of Parking Spaces (Tiba Only)"
            id="parkchirp--payor--integration-settings"
            layout="columns"
          >
              <InputNumberField inputId="parkchirp--payor--num-parking-spaces"
                value={numberOfParkingSpaces}
                onChange={this.props.onSubscriptionNumParkingSpacesChange}
                editMode={(newMode || editMode)}
              />
          </Field>
        </FieldGroup>
      </div>
    );
  }
}
export default InputPayorPanel;
